<template>
  <div>
    <div class="row mb-3">
      <div class="col col-sm-3 col-12">
        <input type="text" class="form-control" v-model="data.result" placeholder="Result">
      </div>
      <div class="col col-sm-1 col-12">
        <span class="input-group-text">=</span>
      </div>
      <div class="col col-sm-3 col-12">
        <input type="text" class="form-control" v-model="data.val1" placeholder="Value 1">
      </div>
      <div class="col col-sm-2 col-12">
        <select name="operator" v-model="data.operator" class="form-control">
          <option v-for="(operator,index) in operators" :value="operator.toLowerCase()" :key="index">{{operator}}</option>
        </select>
      </div>
      <div class="col col-sm-3 col-12">
        <input type="text" class="form-control" v-model="data.val2" placeholder="Value 2">
      </div>
    </div>
    <div class="alert alert-info">
        {{help[data.operator]}}
    </div>
  </div>
</template>


<script type="text/javascript">

  export default {
    name: 'ArithmeticOperation',
    components: {
    },
    props: {
      data: Object
    },
    data: function() {
      return {
        operators: ["+", "-", "x", "/", "%", "**", "//"],
        help:{
          "+": "+ : Addition operation returns the sum of two numbers.",
          "-": "- : Subtraction operation returns the difference of two numbers.",
          "x": "x : Multiplication operation returns the product of two numbers.",
          "/": "/ : Division operation returns the quotient of two numbers.",
          "%": "% : Modulo operation returns the remainder of a division",
          "**": "** : Exponentiation operation returns the result of a number raised to a power",
          "//": "// : Floor division operation returns the quotient of a division with the remainder discarded",
        }
      }
    }
  }
</script>
